"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuditLogApi = void 0;
exports.createAuditLogApi = (axios) => ({
    getProjectAuditLogs(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get(`/project/${projectId}/auditLog`)).data;
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXVkaXRMb2dBcGkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYXBpL2F1ZGl0TG9nQXBpLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUdhLFFBQUEsaUJBQWlCLEdBQUcsQ0FBQyxLQUFvQixFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3BELG1CQUFtQixDQUFDLFNBQWlCOztZQUN6QyxPQUFPLENBQUMsTUFBTSxLQUFLLENBQUMsR0FBRyxDQUFDLFlBQVksU0FBUyxXQUFXLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztRQUNsRSxDQUFDO0tBQUE7Q0FDRixDQUFDLENBQUMifQ==